import util from '@bmp-vue/core/api/util'

const controller = 'Projeto'
export default Object.assign({}, util.GetCrud(controller, null))
